/**
 * MEU ERP API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CompanyInfo { 
    id?: string;
    name?: string;
    employee_code_prefix?: string;
    cellphone?: string;
    website?: string;
    email?: string;
    fax?: string;
    address?: string;
    login_contact_description?: string;
    logo?: string;
    modified_at?: Date;
    modified_by?: string;
    naming_culture?: boolean;
    is_default?: boolean;
    created_at?: Date;
    created_by?: string;
}